import { mountNav } from '../components/Header';
import { login } from '../api/client';

export function LoginPage(): void {
    const app = document.getElementById('app');
    if (!app) return;

    app.innerHTML = `
        <div class="container">
            <header class="header">
                <h1>Mediabin</h1>
                <nav id="nav"></nav>
            </header>
            <main class="main">
                <h2>Log In</h2>
                <form id="login-form">
                    <div class="option-group">
                        <label>Username</label>
                        <input id="username" type="text" autocomplete="username" required>
                    </div>
                    <div class="option-group">
                        <label>Password</label>
                        <input id="password" type="password" autocomplete="current-password" required>
                    </div>
                    <div class="actions">
                        <button class="btn btn-primary" type="submit">Log In</button>
                    </div>
                    <p id="auth-error" class="error-msg" style="display: none;"></p>
                </form>
                <p>No account? <a href="/register">Register</a></p>
            </main>
        </div>
    `;

    mountNav();
    const form = document.getElementById('login-form');
    form?.addEventListener('submit', async (e) => {
        e.preventDefault();
        const username = (document.getElementById('username') as HTMLInputElement).value;
        const password = (document.getElementById('password') as HTMLInputElement).value;
        const err = document.getElementById('auth-error');
        try {
            await login(username, password);
            const next = new URLSearchParams(window.location.search).get('next');
            let target = '/';
            if (next) {
                try {
                    const url = new URL(next, window.location.origin);
                    if (url.origin === window.location.origin) target = url.pathname + url.search + url.hash;
                } catch {
                    target = '/';
                }
            }
            window.location.href = target;
        } catch (error) {
            if (err) {
                err.style.display = 'block';
                err.textContent = error instanceof Error ? error.message : 'Login failed';
            }
        }
    });
}
